module.exports = __webpack_public_path__ + "static/media/placetopay-logo.63fa51b5.svg";